import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Products from "./Pages/Products";
import Blog from './Pages/blogs/Blog';

import Contact from "./Pages/Contact";
import Car from "./Pages/Car";
import Service from "./Pages/Service";
import Gear from "./Pages/Gear"
import PrivacyPolicy from "./Pages/privacy_policy";
import Product6724 from "./Pages/engine-oil/synthetic/6724";
import Product6726 from "./Pages/engine-oil/synthetic/6726";
import Product6711 from "./Pages/engine-oil/synthetic/6711";
import Product6702 from "./Pages/engine-oil/synthetic/6702";
import Product6501 from "./Pages/engine-oil/synthetic/6501";
import Product6201 from "./Pages/motor-oil/motorcycle-oils/6201";
import Product6208 from "./Pages/motor-oil/motorcycle-oils/6208";
import Product3002 from "./Pages/service-fluids/service/3002"
import Product4211 from "./Pages/service-fluids/service/4211"
import Product4212 from "./Pages/service-fluids/service/4212"
import Product4213 from "./Pages/service-fluids/service/4213"
import Product6707 from "./Pages/engine-oil/synthetic/6707"
import Product8605 from "./Pages/gear-oils/gear-oil/8605"
import Product8614 from "./Pages/gear-oils/gear-oil/8614"
import Product8615 from "./Pages/gear-oils/gear-oil/8615"
import Product8616 from "./Pages/gear-oils/gear-oil/8616"
import Product8701 from "./Pages/gear-oils/gear-oil/8701"
import Product8702 from "./Pages/gear-oils/gear-oil/8702"
import Product8710 from "./Pages/gear-oils/gear-oil/8710"
import QualityControl from "./Pages/quality-control";
import Production from "./Pages/production"
import Lubas from "./Pages/lubas-tank-farm"
import Packing from "./Pages/metal-packing"

import BlogOne from './Pages/blogs/1';
import Motor from "./Pages/Motor";
import SearchResults from "./Pages/SearchResults";
import AllProduct from "./Pages/Allproduct";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />

        <Route path="/blogs/1" element={<BlogOne />} />

        <Route path="/products/engine-oils-for-cars-and-transporters" element={<Car />} />
        <Route path="/products/engine-oils-for-motobikes-and-outboards" element={<Motor />} />
        <Route path="/products/operating-service-fluids" element={<Service/>} />
        <Route path="/products/gear-oils-transmission-fluids" element={<Gear/>} />




        <Route path="/engine-oil/synthetic/6724" element={<Product6724 />} />
        <Route path="/engine-oil/synthetic/6726" element={<Product6726 />} />
        <Route path="/engine-oil/synthetic/6711" element={<Product6711 />} />
        <Route path="/engine-oil/synthetic/6702" element={<Product6702 />} />
        <Route path="/engine-oil/synthetic/6501" element={<Product6501 />} />

        <Route path="/motor-oil/6201" element={<Product6201 />} />
        <Route path="/motor-oil/6208" element={<Product6208 />} />
        <Route path="/service-fluids/service/3002" element={<Product3002/>} />
        <Route path="/service-fluids/service/4211" element={<Product4211/>} />
        <Route path="/service-fluids/service/4212" element={<Product4212/>} />
        <Route path="/service-fluids/service/4213" element={<Product4213/>} />
          <Route path="/engine-oil/synthetic/6707" element={<Product6707/>} />
          <Route path="/gear-oils/gear-oil/8605" element={<Product8605/>}/>
          <Route path="/gear-oils/gear-oil/8614" element={<Product8614/>}/>
             <Route path="/gear-oils/gear-oil/8615" element={<Product8615/>}/>
             <Route path="/gear-oils/gear-oil/8616" element={<Product8616/>}/>
               <Route path="/gear-oils/gear-oil/8701" element={<Product8701/>}/>
               <Route path="/gear-oils/gear-oil/8702" element={<Product8702/>}/>
               <Route path="/gear-oils/gear-oil/8710" element={<Product8710/>}/>





        <Route path="/quality-control" element={<QualityControl />} />
        <Route path="/production" element={<Production />} />
        <Route path="/lubas-tank-farm" element={<Lubas />} />
        <Route path="/metal-packing" element={<Packing />} />

        
        <Route
          path="/products/engine-oils-for-cars-and-transporters/engine-oil/:type/:id"
          element={<AllProduct />} />
         <Route
          path="/products/engine-oils-for-motorbikes-and-outboards/motor-oil/:type/:id"
          element={<AllProduct />} />

              <Route
          path="/products/operating-service-fluids/service-fluids/service/:type/:id"
          element={<AllProduct />} />
                      <Route
          path="/products/gear-oils-transmission-fluids/gear-oils/:type/:id"
          element={<AllProduct />} />
        
        <Route path="/search" element={<SearchResults />} />
        <Route path="/engine-oil/synthetic/:id" element={<SearchResults />} />






      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
